import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import catalogsClient from '@/axiosClients/catalogsClient'

export const getAttentionServices = async ({ commit }, params = '') => {
    try {
        const { data: result } = await catalogsClient.get(`/attention-services${params}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getNextAttentionServiceKey = async ({ commit }) => {
    try {
        const { data: result } = await catalogsClient.get(`/attention-services/catalog/next-key`)
        const { data, error } = result.result
        return { data, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, data: null, error: true }
    }
}

export const storeAttentionService = async ({ commit }, payload) => {
    try {
        const { data: result } = await catalogsClient.post(`/attention-services/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getPersonalTypesAssociation = async ({ commit }, catalogKey) => {
    try {
        const { data: result } = await catalogsClient.get(`/attention-services/catalog/${catalogKey}/personal-types`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, data: null, error: true }
    }
}

export const updatePersonalTypesAssociation = async ({ commit }, { catalogKey, personalTypeIds }) => {
    try {
        const { data: result } = await catalogsClient.put(`/attention-services/catalog/${catalogKey}/personal-types`, {
            personal_type_ids: personalTypeIds,
        })
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
